import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { MagicLinkComponent } from './auth/magic-link/magic-link.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddCandidateComponent } from './add-candidate/add-candidate.component';
import { CommunicationTemplatesComponent } from './communication-templates/communication-templates.component';
import { CandidateBookingComponent } from './candidate-booking/candidate-booking.component';
import { AuthGuard } from './auth/auth.guard';
import { TemplateManagementGuard } from './shared/guards/role.guard';

export const routes: Routes = [
  // Login is now handled by the session monitor
  {
    path: 'login',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'magiclink',
    component: MagicLinkComponent
  },
  {
    path: 'add-candidate',
    component: AddCandidateComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'sms-templates',
    redirectTo: '/templates',
    pathMatch: 'full'
  },
  {
    path: 'templates',
    component: CommunicationTemplatesComponent,
    canActivate: [AuthGuard, TemplateManagementGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'god',
    loadChildren: () => import('./god/god.module').then(m => m.GodModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'book/candidate/:token',
    component: CandidateBookingComponent
  },
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
